import { createPlugin } from '@backstage/core-plugin-api';
import { useShadowRootElements, createTechDocsAddonExtension, TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { useEffect } from 'react';
import { useTheme } from '@material-ui/core';
import mermaid from 'mermaid';

const mermaidStart = /^(\s*)(graph|flowchart|sequenceDiagram|classDiagram|stateDiagram|erDiagram|journey|gantt|pie|requirementDiagram|gitGraph|C4Context|C4Container|C4Component|C4Dynamic|C4Deployment|timeline)/;
const isMermaidCode = (code) => {
  if (code.startsWith("%%{init")) {
    const codeSplitByDirectiveStart = code.split("%%");
    if (codeSplitByDirectiveStart.length > 2)
      return code.split("%%")[2].match(mermaidStart) !== null;
  }
  return code.match(mermaidStart) !== null;
};

function selectConfig(backstagePalette, properties) {
  if (properties.config) {
    return properties.config;
  }
  if (backstagePalette === "light") {
    return properties.lightConfig || {};
  }
  return properties.darkConfig || {};
}
let diagramId = 0;
const makeDiagram = async (el, diagramText, backstagePalette, properties) => {
  var _a;
  el.style.display = "none";
  const diagramElement = document.createElement("div");
  diagramElement.className = "mermaid";
  (_a = el.parentNode) == null ? void 0 : _a.insertBefore(diagramElement, el.nextSibling);
  const id = `mermaid-${diagramId++}`;
  const config = selectConfig(backstagePalette, properties);
  if (config) {
    mermaid.initialize(config);
  }
  const { svg, bindFunctions } = await mermaid.render(id, diagramText);
  diagramElement.innerHTML = svg;
  bindFunctions == null ? void 0 : bindFunctions(diagramElement);
};
const MermaidAddon = (properties) => {
  const highlightTables = useShadowRootElements([".highlighttable"]);
  const highlightDivs = useShadowRootElements([".highlight"]);
  const mermaidPreBlocks = useShadowRootElements([".mermaid"]);
  const theme = useTheme();
  useEffect(() => {
    highlightTables.forEach((highlightTable) => {
      if (!highlightTable.classList.contains("language-text")) {
        return;
      }
      if (highlightTable.style.display === "none") {
        return;
      }
      const codeBlock = highlightTable.querySelector("code");
      if (!codeBlock) {
        return;
      }
      const diagramText = codeBlock.textContent || "";
      if (!isMermaidCode(diagramText)) {
        return;
      }
      makeDiagram(highlightTable, diagramText, theme.palette.type, properties);
    });
  }, [highlightTables, properties, theme.palette.type]);
  useEffect(() => {
    highlightDivs.forEach((highlightDiv) => {
      if (!highlightDiv.classList.contains("language-text")) {
        return;
      }
      if (highlightDiv.style.display === "none") {
        return;
      }
      const table = highlightDiv.querySelector("table");
      if (!table) {
        return;
      }
      const codeBlock = highlightDiv.querySelector("code");
      if (!codeBlock) {
        return;
      }
      const diagramText = codeBlock.textContent || "";
      if (!isMermaidCode(diagramText)) {
        return;
      }
      makeDiagram(highlightDiv, diagramText, theme.palette.type, properties);
    });
  }, [highlightDivs, properties, theme.palette.type]);
  useEffect(() => {
    mermaidPreBlocks.forEach((mermaidPreBlock) => {
      if (mermaidPreBlock.style.display === "none") {
        return;
      }
      const codeBlock = mermaidPreBlock.querySelector("code");
      if (!codeBlock) {
        return;
      }
      const diagramText = codeBlock.textContent || "";
      makeDiagram(mermaidPreBlock, diagramText, theme.palette.type, properties);
    });
  }, [mermaidPreBlocks, properties, theme.palette.type]);
  return null;
};

const techdocsAddonMermaidPlugin = createPlugin({
  id: "techdocs-addon-mermaid"
});
const Mermaid = techdocsAddonMermaidPlugin.provide(
  createTechDocsAddonExtension({
    name: "MermaidDiagram",
    location: TechDocsAddonLocations.Content,
    component: MermaidAddon
  })
);

export { Mermaid, techdocsAddonMermaidPlugin };
//# sourceMappingURL=index.esm.js.map
